/* Oslo Signatur – velkomstvindu.
   Vises én gang for nye besøkende. Etter «Nei takk» vises det ikke igjen på 30 dager,
   og etter påmelding vises det aldri igjen i samme nettleser. */
(() => {
  if (window.osloVelkomstLoaded) return;
  window.osloVelkomstLoaded = true;

  const STORAGE_KEY = 'osloVelkomst';
  const SUBMIT_FLAG = 'osloVelkomstSubmitted';
  const DISMISS_DAYS = 30;

  const store = {
    get(storage, key) {
      try { return window[storage].getItem(key); } catch (e) { return null; }
    },
    set(storage, key, value) {
      try { window[storage].setItem(key, value); } catch (e) { /* ignorer */ }
    },
    remove(storage, key) {
      try { window[storage].removeItem(key); } catch (e) { /* ignorer */ }
    },
  };

  function readState() {
    const raw = store.get('localStorage', STORAGE_KEY);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function writeState(status) {
    store.set('localStorage', STORAGE_KEY, JSON.stringify({ status, at: Date.now() }));
  }

  function shouldAutoOpen() {
    const state = readState();
    if (!state) return true;
    if (state.status === 'subscribed') return false;
    if (state.status === 'dismissed') {
      return Date.now() - (state.at || 0) > DISMISS_DAYS * 24 * 60 * 60 * 1000;
    }
    return true;
  }

  function setup() {
    const root = document.getElementById('OsloVelkomst');
    if (!root || root.dataset.osloReady === 'true') return;
    root.dataset.osloReady = 'true';

    // Flytt vinduet rett under <body>, så ingen overskrift eller meny legger seg over det.
    if (root.parentElement !== document.body) document.body.appendChild(root);

    const designMode = root.dataset.designMode === 'true';
    const enabled = root.dataset.enabled === 'true';
    const dialog = root.querySelector('.oslo-velkomst__dialog');
    const stateEl = root.querySelector('[data-oslo-velkomst-state]');
    const formState = stateEl ? stateEl.dataset.osloVelkomstState : 'form';
    const form = root.querySelector('form');
    const submittedHere = store.get('sessionStorage', SUBMIT_FLAG) === '1';
    let lastFocus = null;
    let timer = null;

    function open() {
      if (!root.hidden) return;
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('oslo-velkomst-locked');
      requestAnimationFrame(() => {
        root.classList.add('is-open');
        dialog.focus({ preventScroll: true });
      });
      document.addEventListener('keydown', onKeydown);
    }

    function close(remember = true) {
      if (root.hidden) return;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('oslo-velkomst-locked');
      document.removeEventListener('keydown', onKeydown);
      if (remember && !designMode && formState !== 'success') writeState('dismissed');
      setTimeout(() => { root.hidden = true; }, 280);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(
        dialog.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')
      ).filter((el) => !el.disabled && el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    root.querySelectorAll('[data-oslo-velkomst-close]').forEach((el) =>
      el.addEventListener('click', () => close())
    );

    if (form) {
      form.addEventListener('submit', () => store.set('sessionStorage', SUBMIT_FLAG, '1'));
    }

    // Temaredigereren: vis vinduet når seksjonen er valgt.
    if (designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail && event.detail.sectionId === root.dataset.sectionId) open();
      });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail && event.detail.sectionId === root.dataset.sectionId) close(false);
      });
      return;
    }

    // Svar etter innsending fra dette vinduet.
    if (formState === 'success') {
      writeState('subscribed');
      if (submittedHere) {
        store.remove('sessionStorage', SUBMIT_FLAG);
        open();
      }
      return;
    }

    if (formState === 'error') {
      // Feilmeldingen kan komme fra et annet skjema på siden; vis den bare når den gjelder dette vinduet.
      if (submittedHere) {
        store.remove('sessionStorage', SUBMIT_FLAG);
        open();
      }
      return;
    }

    if (!enabled || !shouldAutoOpen()) return;

    const delay = Math.max(1, parseInt(root.dataset.delay, 10) || 5) * 1000;
    timer = setTimeout(open, delay);
    window.addEventListener('pagehide', () => clearTimeout(timer), { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  document.addEventListener('shopify:section:load', () => {
    // Fjern et gammelt vindu som ble flyttet til <body>, før det nye settes opp.
    Array.from(document.body.children)
      .filter((el) => el.id === 'OsloVelkomst' && el.dataset.osloReady === 'true')
      .forEach((el) => el.remove());
    document.documentElement.classList.remove('oslo-velkomst-locked');
    setup();
  });
})();
